import { Box, Card, Grid } from '@mui/material';

import { SettingsHeader } from '../../components/SettingsHeader';
import SettingsIndex from '../../components/SettingsIndex';

import CustomizeBusinessDefinition from './customizeBusinessDefinition/CustomizeBusinessDefinition';
import CustomizeStageStatus from './customizeStageStatus/CustomizeStageStatus';
import SubmissionStageStatusSettings from './customizeSubmissionStageStatus/CustomizeSubmissionStageStatus';

interface IStageStatusSettingsProps {
  type: string;
}

const titleMap: Record<string, string> = {
  stage: 'Customize Stage Status',
  business: 'Customize Business Definition',
  submission: 'Customize Submission Stage Status',
};

const componentMapping: Record<string, React.ReactNode> = {
  stage: <CustomizeStageStatus />,
  business: <CustomizeBusinessDefinition />,
  submission: <SubmissionStageStatusSettings />,
};

const settingsOptions = [
  { label: 'Stage Status Settings', url: '/candidate-stage-status-pipeline-settings' },
  {
    label: 'Business Definition Settings',
    url: '/candidate-stage-status-pipeline-settings/business-definition',
  },
  {
    label: 'Submission Stage Status Settings',
    url: '/candidate-stage-status-pipeline-settings/submission',
  },
];

const StageStatusSettings = ({ type }: IStageStatusSettingsProps) => (
  <Box>
    <Grid container columnSpacing={3} rowSpacing={4}>
      <Grid item xs={12}>
        <SettingsHeader title={titleMap[type] || 'Customize Submission Stage Status'} />
      </Grid>
      <Grid item xs={3}>
        <SettingsIndex index="" options={settingsOptions} />
      </Grid>
      <Grid item xs={9}>
        <Card sx={{ minHeight: '83vh', width: '100%', p: 0 }}>
          {componentMapping[type] || <CustomizeBusinessDefinition />}
        </Card>
      </Grid>
    </Grid>
  </Box>
);
export default StageStatusSettings;
